<form [formGroup]="form" (ngSubmit)="onSubmit(model)" *ngIf="ready" [@quickFadeIn] autocomplete="nope">
  <formly-form
    class="slds-grid slds-wrap slds-gutters case-form-alignment"
    [form]="form"
    [fields]="fields"
    [model]="model"
    [options]="options"
  ></formly-form>
  <div class="slds-col slds-size_1-of-1 form-footer">
    <div class="button-wrapper">     
      <button *ngIf="navigationHistory" type="button" nglButton variant="neutral" (click)="openPopup()">
        {{ 'cases.back_to_search' | translate }}
      </button>
      <button *ngIf="caseId.length" type="button" nglButton variant="neutral" (click)="showVoidModal = true">
        {{ 'cases.void' | translate }}
      </button>
      <button type="submit" nglButton variant="brand">
        {{ (caseId.length ? 'userPreferences.saveBtn' : 'createCase.submitBtn') | translate }}
      </button>
    </div>
  </div>
</form>

<ups-modal-confirm
  [headerLabel]="'cases.void_case' | translate"
  [opened]="showVoidModal"
  [cancelBtn]="true"
  [confirmBtnLabel]="'cases.void' | translate"
  [cancelBtnLabel]="'cases.cancel' | translate"
  (cancel)="showVoidModal = false"
  (confirm)="voidCase()"
  (visibilityChanged)="showVoidModal = $event"
>
  <ng-container *ngIf="showVoidModal">
    <form [formGroup]="reasonToVoidForm">
      <label>{{ 'cases.reason_to_void' | translate }}</label>
      <ngl-textarea>
        <textarea #control="" ngl [formControlName]="'reason'" [required]="true"></textarea>
      </ngl-textarea>
    </form>
  </ng-container>
</ups-modal-confirm>

<ups-modal-confirm
  [headerLabel]="'cases.back_to_search' | translate"
  [opened]="showConfirmModal"
  [cancelBtn]="true"
  [confirmBtnLabel]="'cases.continue' | translate"
  [cancelBtnLabel]="'cases.cancel' | translate"
  (cancel)="showConfirmModal = false"
  (confirm)="back()"
  (visibilityChanged)="showConfirmModal = $event"
>
  <ng-container *ngIf="showConfirmModal">
    
      <label>{{ 'cases.case_updates_will_not_be_saved' | translate }}</label>
      
  </ng-container>
</ups-modal-confirm>

<ups-modal-confirm
  headerLabel="Error Summary"
  [opened]="showErrorSummaryModal"
  [cancelBtn]="false"
  confirmBtnLabel="Ok"
  (confirm)="showErrorSummaryModal = false"
  (visibilityChanged)="showErrorSummaryModal = $event"
>
  <ng-container *ngIf="showErrorSummaryModal">
    <ul class="error-summary">
      <ng-container *ngFor="let error of getFormValidationErrors()">
        <li *ngIf="error.section" class="section">
          <b>{{ error.section }}</b>
        </li>
        <li *ngIf="error.error">- {{ error.label }}</li>
      </ng-container>
    </ul>
  </ng-container>
</ups-modal-confirm>
